import { render } from "./FileCommentItem.vue?vue&type=template&id=7f3f950a&ts=true"
import script from "./FileCommentItem.vue?vue&type=script&lang=ts"
export * from "./FileCommentItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__